import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import selectors from '../../../rootSelectors';
import AvatarView from '../../../common/avatar/avatarView';
import withAvatar from '../../../common/avatar/withAvatar';
import { goToReading } from '../../../common/navigation/navigationActions';
import { TRC } from '../../../constants/measure';
import { unmountScreen } from '../../../common/screen/screenActions';
import ReadingTip from '../../../common/components/ReadingTip';
import { getTrcInstruction, getTrcCaption } from '../../troConstants';
import { narrateScreen } from '../../trcActions';
import TRCCountdownView from './TRCCountdownView';
import { narrateReset, stopAudio } from '../../../common/audio/audioActions';

const instructionsKey = 'trcCountdownReminder';

const mapDispatchToProps = (dispatch) => ({
    onEndCounting: () => {
        dispatch(goToReading(TRC));
    },
    cleanup: () => {
        dispatch(unmountScreen());
        dispatch(stopAudio());
        dispatch(narrateReset());
    },
    narrateScreen: (isExternalURLSourcePresent, arLanguage) => {
        const instruction = getTrcInstruction(isExternalURLSourcePresent, instructionsKey, arLanguage);
        const caption = getTrcCaption(isExternalURLSourcePresent, instructionsKey, arLanguage);
        dispatch(narrateScreen(instruction, caption));
    },
});

const mapStateToProps = (state) => ({
    countdownTitle: <ReadingTip />,
    isExternalURLSourcePresent: selectors.getExternalURLSourceStatus(state),
    isPaused: selectors.getIsPaused(state),
    arLanguage: selectors.getArLanguage(state),
});

const avatarProps = (state) => ({
    position: AvatarView.Position.LOWER_LEFT,
    instructions: getTrcInstruction(selectors.getExternalURLSourceStatus(state), instructionsKey, selectors.getArLanguage(state)),
});

const TRCCountdownContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarProps),
)(TRCCountdownView);

export default TRCCountdownContainer;
